module.exports = __webpack_public_path__ + "media/images/ads/brands_desktop-218d22985f067d7d80bc32441d3d513b.png";